module.exports = __webpack_public_path__ + "img/social-icon-wp.86bb33ea.png";